import { render, staticRenderFns } from "./user_auth.vue?vue&type=template&id=9f05e13a&scoped=true&"
import script from "./user_auth.vue?vue&type=script&lang=js&"
export * from "./user_auth.vue?vue&type=script&lang=js&"
import style0 from "./user_auth.vue?vue&type=style&index=0&id=9f05e13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f05e13a",
  null
  
)

export default component.exports